export const Main: React.FC<{}> = (): JSX.Element => {
  return <div> legal</div>
}
export default Main
